<template>
  <div class="page p-create-mt">
    <header>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/pt/exercise-center' }"
          >练习中心</el-breadcrumb-item
        >
        <el-breadcrumb-item>同步练习</el-breadcrumb-item>
      </el-breadcrumb>
      <card-header class="mt-20">同步练习</card-header>
      <div class="s-tabs">
        <div class="s-nav-container">
          <div class="s-tab-nav"></div>
        </div>
        <div class="hr"></div>
      </div>
    </header>
    <div class="create-at-content">
      <div class="f-left" ref="container">
        <div class="selector-container">
          <div
            class="version-header"
            @click="showVersion = !showVersion"
            :class="showVersion ? 'is-blue' : ''"
          >
            <p
              v-if="
                categoryObj.subjectId !== '' &&
                categoryObj.gradeId !== '' &&
                categoryObj.textbookId !== ''
              "
            >
              <span class="result-text">{{ categoryObj.subjectName }}</span> -
              <span class="result-text"
                >{{ categoryObj.gradeName }}{{ categoryObj.termName }}</span
              >
              -
              <span class="result-text">{{ categoryObj.textbookName }}</span>
            </p>
            <div v-else>
              <div>请选择教材版本</div>
              <div v-if="showSubject" class="empty-tip">
                请选择你要布置的练习的教材
                <el-button @click.stop="changeSubject" type="primary" size="small">我知道了</el-button>
              </div>
            </div>
          </div>
          <!-- 选择教材版本 -->
          <choise-category
            v-if="showVersion"
            fromType="3"
            @hideSubjectGradeText="hideSubjectGradeText"
          ></choise-category>
        </div>
        <!-- 理科选择知识点 -->
        <choose-knowledgePoints
          :data="chapterList"
          :fromType="3"
          @toggle="onToggle"
          v-if="
            categoryObj.subjectId !== '' &&
            categoryObj.gradeId !== '' &&
            categoryObj.textbookId !== '' &&
            scienceArr.includes(Number(this.categoryObj.subjectId))"
        ></choose-knowledgePoints>
        <!-- 文科选择课时 -->
        <choose-tagCode
          :data="chapterList"
          @toggleTag="onToggleTag"
          v-else
        ></choose-tagCode>
      </div>
      <div class="f-main">
        <Filtrate
          v-if="categoryObj.subjectId !== '' &&
            categoryObj.gradeId !== '' &&
            categoryObj.textbookId !== ''"
          :questionList="questionList"
          :knowledgeName="knowledgeName"
          @clearPage="clearPage"
        ></Filtrate>
        <question-content :questionList="filtrateArray" />
      </div>
    </div>
    <!-- 试题篮 -->
    <div
      class="basket pointer"
      @click="goQuestionBasket"
      v-show="questionsBasket && questionsBasket.length > 0"
    >
      <p class="basket-content">试题篮</p>
      <p class="basket-number">{{ totalCount }}/50</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CRM_USER } from '@/config/storage';
import _ from 'lodash';
import {
  getCmsCourseTree, getQuestionByCodes, getQuestionPackageList, getQuestionByPackage,
} from '@/api/pt';
import CardHeader from '@/components/card-header.vue';
import ChoiseCategory from './components/choose-category.vue';
import ChooseKnowledgePoints from './components/choose-knowledgePoints.vue';
import ChooseTagCode from './components/choose-tagCode.vue';
import QuestionContent from './components/question-content.vue';
import Filtrate from './components/filtrate.vue';
import { isScienceArr } from '@/utils';

export default {
  name: 'CreateMt',
  components: {
    CardHeader,
    ChoiseCategory,
    ChooseKnowledgePoints,
    ChooseTagCode,
    QuestionContent,
    Filtrate,
  },
  data() {
    const userInfo = JSON.parse(localStorage.getItem(CRM_USER)) || {};
    return {
      scienceArr: [2, 4, 5],
      showVersion: false,
      userInfo,
      chapterList: [],
      showSubject: true,
      subjectId: '',
      gradeId: '',
      termId: '',
      textbookId: '',
      questionList: [],
      currentKnowledgeCode: '',
      currentPackageId: '',
      knowledgeName: '',
      packInfoList: [],
      preParams: {},
    };
  },
  computed: {
    ...mapGetters(['categoryObj', 'questionsBasket', 'filtrateArray']),
    totalCount() {
      let count = 0;
      this.questionsBasket.forEach((item) => {
        if (item.child_question_num > 0) {
          count += item.child_question_num;
        } else {
          count += 1;
        }
      });
      return count;
    },
  },
  methods: {
    clearPage(code) {
      this.page = 1;
      this.pageSize = 10;
      this.currentKnowledgeCode = code;
      this.getQuestionByPackage();
      // this.queryClassCommonWrongQuestionList();
    },
    changeSubject() {
      this.showSubject = false;
    },
    // 重新选择版本操作
    hideSubjectGradeText(isNeedQuery) {
      this.showVersion = false;
      this.knowledgeName = '';
      if (isNeedQuery) {
        this.queryCourseTree();
      }
    },
    // 查询当前版本章节列表
    queryCourseTree() {
      this.chapterList = [];
      this.questionList = [];
      this.subjectId = this.categoryObj.subjectId;
      this.gradeId = this.categoryObj.gradeId;
      this.textbookId = this.categoryObj.textbookId;
      this.termId = this.categoryObj.termId;
      const params = {
        subject_id: this.subjectId,
        grade_id: this.gradeId,
        textbook_id: this.textbookId,
        extend_info: 1,
        term_id: this.termId,
        hw_type: 3,
      };
      getCmsCourseTree(params).then((res) => {
        if (res.code === 200) {
          const chapterArr = res.data;
          chapterArr.forEach((item, index) => {
            if (index === 0) {
              // FIX:此处 bug packInfoList  此时是空数组,依赖 bug 运行成功
              this.getQuestionPackageList(item);
              this.chapterList.push({
                course_id: item.course_id,
                // 理科用lesson_id来获取packInfo
                lesson_id: item.lesson_id,
                lesson_name: item.lesson_name,
                // 文科用module_id来获取packInfo
                module_id: item.module_id,
                module_name: item.module_name,
                packInfo: this.packInfoList,
                active: true,
              });
            } else {
              this.chapterList.push({
                course_id: item.course_id,
                lesson_id: item.lesson_id,
                lesson_name: item.lesson_name,
                module_id: item.module_id,
                module_name: item.module_name,
                active: false,
              });
            }
          });
        }
      });
    },
    // 根据课次获取对应的知识点列表
    async getQuestionPackageList(item) {
      this.packInfoList = [];
      const courseInfo = {
        courseId: item.course_id,
        courseName: item.course_name,
        lessonId: item.lesson_id,
      };
      this.$store.commit('CHANGE_COURSE_INFORMATION', courseInfo);
      const params = {
        subject_id: this.categoryObj.subjectId,
        hw_type: 3,
        module_id: isScienceArr(this.categoryObj.subjectId) ? item.lesson_id : item.module_id,
      };
      await getQuestionPackageList(params).then((res) => {
        if (res.code === 200) {
          const knowledgeArr = res.data;
          if (knowledgeArr.length > 0) {
            // 文理科知识点数据结构不一样,理科
            if (isScienceArr(this.categoryObj.subjectId)) {
              knowledgeArr.forEach((knowledge) => {
                this.packInfoList.push({
                  tag_code: knowledge.tag_code,
                  tag_name: knowledge.tag_name,
                  active: false,
                  type: '理科',
                });
              });
            } else {
              knowledgeArr.forEach((knowledge) => {
                knowledge.list.forEach((tag) => {
                  this.$set(tag, 'active', false);
                });
                this.packInfoList.push({
                  topic_id: params.module_id,
                  id: knowledge.id,
                  question_pack_id: knowledge.id,
                  tag_name: knowledge.name,
                  k_module: knowledge.k_module,
                  k_module_name: knowledge.k_module_name,
                  list: knowledge.list,
                  rand_id: knowledge.rand_id,
                  sort: knowledge.sort,
                  active: false,
                  type: '文科',
                  question_list: [],
                  question_info_list: [],
                });
              });
              // 默认展开第一个
              this.$set(this.packInfoList[0], 'active', true);
              this.onToggleTag(this.packInfoList[0]);
              this.$store.commit('SET_TOPIC_LIST', this.packInfoList);
            }
          }
        }
      });
    },
    // 理科知识点点击操作
    onToggle(item) {
      this.currentKnowledgeCode = item.tag_code;
      this.knowledgeName = item.tag_name;
      this.getQuestionByCodes();
    },
    // 文科知识点点击操作
    onToggleTag(packItem, tagItem) {
      console.log('packItem---------------', packItem, tagItem);
      const topicId = packItem.topic_id;
      const kModule = packItem.k_module;
      const kModuleName = packItem.k_module_name;
      this.knowledgeName = packItem.tag_name;
      this.currentPackageId = packItem.id;
      this.currentKnowledgeCode = (tagItem && tagItem.tag_code)
        || packItem.tag_code
        || this.getPackCodes(packItem.list);
      this.getQuestionByPackage(topicId, kModule, kModuleName, this.currentPackageId);
      this.$store.commit('SELECT_TAG_ARRAY', packItem.list);
    },
    // 获取第一个节点的 code
    getPackCodes(list) {
      // return list.map((item) => item.tag_code).join(',');
      return _.get(list, '0.tag_code');
    },
    // 理科根据知识点获取试题列表
    getQuestionByCodes() {
      this.questionList = [];
      getQuestionByCodes({ tag_codes: this.currentKnowledgeCode }).then((res) => {
        if (res.code === 200) {
          const questionArr = res.data.list;
          this.questionList = Object.values(questionArr);
          this.questionList.forEach((item) => {
            this.$set(item, 'active', false);
          });
        }
      });
    },
    // 文科根据知识点获取试题列表
    getQuestionByPackage(topicId, kModule, kModuleName, id) {
      this.questionList = [];
      const params = {
        knowledge_codes: this.currentKnowledgeCode.split(',')[0],
        package_id: this.currentPackageId,
      };
      this.preParams = {
        topicId, kModule, kModuleName, id,
      };
      getQuestionByPackage(params).then((res) => {
        if (res.code === 200) {
          this.questionList = res.data.list;
          this.questionList.forEach((item) => {
            this.$set(item, 'active', false);
            this.$set(item, 'topic_id', topicId || this.preParams.topicId);
            this.$set(item, 'p_k_module', kModule || this.preParams.kModule);
            this.$set(item, 'p_k_module_name', kModuleName || this.preParams.kModuleName);
            this.$set(item, 'id', id || this.preParams.id);
          });
        }
      });
    },
    // 去试题篮
    goQuestionBasket() {
      this.$router.push({
        path: '/pt/question-basket',
        query: {
          fromType: 'mt',
        },
      });
    },
  },
  activated() {
    // 缓存处理
    if (!this.$route.meta.isUseCache) {
      console.log('不使用缓存----------------');
      this.knowledgeName = '';
      this.chapterList = [];
      this.questionList = [];
      this.$store.commit('FILTRATE_ARRAY', []);
      if (this.categoryObj.subjectId !== '' && this.categoryObj.gradeId !== '' && this.categoryObj.textbookId !== '') {
        this.queryCourseTree();
      }
    } else {
      this.$route.meta.isUseCache = false;
    }
  },
  deactivated() {
    this.showVersion = false;
  },
};
</script>

<style lang="scss" scoped>
.p-create-mt {
  header {
    background: url("../images/sync_study.png") no-repeat right center;
    background-size: 600px 90px;
  }
  .create-at-content {
    display: flex;
  }
  .f-left {
    width: 256px;
    box-shadow: 2px 0px 8px 0px rgba(220, 225, 236, 0.5);
    padding-top: 6px;
    min-height: 780px;
    z-index: 2;
  }
  .f-main {
    flex: 1;
  }
  .selector-container {
    margin-bottom: 30px;
    .version-header {
      width: 240px;
      height: 40px;
      border-radius: 4px;
      border: 1px solid #c4c8d2;
      line-height: 40px;
      font-size: 14px;
      padding: 0 15px;
      box-sizing: border-box;
      overflow: hidden;
    }
    .is-blue {
      border: 1px solid #1989fa;
    }
  }
  .c-subtile {
    color: rgba(48, 49, 51, 0.6);
    font-size: 14px;
    margin-top: 40px;
    padding-bottom: 20px;
  }
  .basket {
    position: fixed;
    top: 160px;
    right: 0px;
    width: 56px;
    height: 170px;
    background: #1989fa;
    box-shadow: 0px 2px 6px 0px rgba(129, 172, 223, 0.51);
    border-radius: 8px;
    .basket-content {
      padding-top: 30px;
      text-align: center;
      margin: 10px auto;
      width: 26px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      background: url("../images/question_basket.png") no-repeat;
      background-size: 26px 24px;
    }
    .basket-number {
      margin: 16px auto;
      width: 38px;
      height: 38px;
      background: #81acdf;
      border-radius: 50%;
      line-height: 38px;
      text-align: center;
      font-size: 13px;
      font-weight: 400;
      color: #ffffff;
    }
  }
}
.empty-tip {
    position: absolute;
    width: 250px;
    height: 95px;
    text-align: center;
    color: #FFF;
    padding-top: 20px;
    font-size: 14px;
    background: url('~@/views/pt/images/Combined-Shape.png') no-repeat left top / 100% 100%;
    .el-button--small {
      position: absolute;
      right: 20px;
      bottom: 26px;
    }
  }
</style>
